module.exports = __webpack_public_path__ + "9d48063c0f344ddcb675802eee0e7023.MP3";